import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut, changeLoations } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { AlocacoesRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class AlocacaoServices {
    constructor() {
        this.alocacoesRequests = new AlocacoesRequests();
    }

    // Busca dados do equipamento
    async getAlocacao(id){
        try {
            const response = await this.alocacoesRequests.getAlocacao(id);
            return response.data;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Envia o usuário para ser editado
    async editAlocacao (Id, alocation){
        try {
            const response = await this.alocacoesRequests.editAlocacao(Id, alocation);
            toast(i18n.t("message.allocation-service.response-edit-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca todos equipamentos
    async getAllAlocacoes(search, page){
        try {
            const response = await this.alocacoesRequests.getAllAlocacoes(search, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Cria um novo equipamento
    async SaveAlocacao (alocation){
        try {
            const response = await this.alocacoesRequests.CreateAlocacao(alocation);
            toast(i18n.t("message.allocation-service.response-save-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca alocações que o usuário pode ver
    async getLocations(){
        try {
            const response = await this.alocacoesRequests.getlocations();
            this.locations = response;
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca tipos de alocações que o usuário pode ver
    async getLocationsType(){
        try {
            const response = await this.alocacoesRequests.getlocationsType();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Muda o tipo de alocações sendo exibido
    ChangeLocationType(type){
        if(type === '6f9d2274-09ed-45d8-96b3-11ee4073da51'){
            store.dispatch(changeLoations([]));
        }else{
            let newtype = type === '153b08f5-3bac-4614-a325-70f2cc84adc7' ? 'Entidades' : type === '941685e4-0fe4-465e-b976-485443cfbb8e' ? 'Grupos' : ''
            store.dispatch(changeLoations(this.locations[newtype]));
        }
    }
    
    // Busca
    async getStates(){
        try {
            const response = await this.alocacoesRequests.getStates();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca
    async getCities(state){
        try {
            const response = await this.alocacoesRequests.getCities(state);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Adiciona equipamento a alocação
    async addEquipamentToAlocacao(id, equipament){
        try {
            const response = await this.alocacoesRequests.addEquipamentToAlocacao(id, equipament);
            toast(i18n.t("message.allocation-service.response-add-equipament-to-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Remove equipamento da alocação
    async removeEquipamentFromAlocacao(id, equipament){
        try {
            const response = await this.alocacoesRequests.removeEquipamentToAlocacao(id, equipament);
            toast(i18n.t("message.allocation-service.response-remove-equipament-from-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Adiciona cidade a alocação
    async addCityToAlocacao(id, city){
        try {
            const response = await this.alocacoesRequests.addCityToAlocacao(id, city);
            toast(i18n.t("message.allocation-service.response-add-city-to-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Remove cidade da alocação
    async removeCityFromAlocacao(id, city){
        try {
            const response = await this.alocacoesRequests.removeCityToAlocacao(id, city);
            toast(i18n.t("message.allocation-service.response-remove-city-from-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Pega todos equipamentos
    async getEquipaments(alocacaoId){
        try {
            const response = await this.alocacoesRequests.getEquipaments(alocacaoId);
            return response.authorized_equipments;
        } catch (error) {
            toast(i18n.t("message.allocation-service.error-get-equipaments"), {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return [];
        }
    }

    // Pega todas cidades
    async getAllCities(alocacaoId){
        try {
            const response = await this.alocacoesRequests.getAllCities(alocacaoId);
            return response.authorized_cities;
        } catch (error) {
            toast(i18n.t("message.allocation-service.error-get-all-cities"), {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
            });
            return [];
        }
    }
}